export const selectableMaterials : Array<ISelectableSheetMaterial> = [
	{ family: 'stålplåt', density: 7850 },
	{ family: 'aluminium', density: 2700 },
	{ family: 'zink', density: 7135 },
	{ family: 'rostfritt', density: 7800 },
	{ family: 'mässing', density: 8500 },
	{ family: 'koppar', density: 8940 },
	{ family: 'aluzink', density: 7135 },
]